module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "account-subscription"
  }, [_c('div', {
    staticClass: "account-subscription__text mb-4"
  }, [_vm._v("Current Plan")]), _vm._v(" "), _c('div', {
    staticClass: "current-plan d-flex",
    class: _vm.$vuetify.breakpoint.width > 650 ? '' : 'flex-wrap gap-10'
  }, [_vm._m(0), _vm._v(" "), _vm._m(1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-flex flex-column gap-4"
  }, [_c('div', {
    staticClass: "plan-name"
  }, [_vm._v("PREMIUM")]), _vm._v(" "), _c('div', {
    staticClass: "note text-black"
  }, [_vm._v("(Monthly)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-flex flex-column align-end gap-4"
  }, [_c('div', [_c('span', {
    staticClass: "account-subscription__text"
  }, [_vm._v("$12")]), _vm._v(" "), _c('span', {
    staticClass: "note text-black"
  }, [_vm._v("/month")])]), _vm._v(" "), _c('div', {
    staticClass: "note font-weight-500"
  }, [_vm._v("Cancel")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-976858f2","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/settings/components/account_subscription.vue
// module id = 1818
// module chunks = 180